import React from 'react';

import { BuilderBlocks } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import AssetNode from '~/shared/components/AssetNode';

const AssetOverlayWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;
const AssetNodeContainer = styled(AssetNode)``;

const BuilderBlocksOverlayContent = styled(BuilderBlocks)`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const BuilderAssetOverlay = ({
  builderBlock,
  overlay,
  container,
  mobileContainer,
  ...rest
}) => {
  if (!container) {
    return <h1>You must enter an asset to use this component</h1>;
  }
  return (
    <AssetOverlayWrapper>
      <AssetNodeContainer
        container={container}
        mobileContainer={mobileContainer}
        {...rest}
      />
      <BuilderBlocksOverlayContent
        id="testhelen"
        className="testHelenClass"
        parentElementId={builderBlock.id}
        dataPath="component.options[1]"
        blocks={overlay}
      />
    </AssetOverlayWrapper>
  );
};

BuilderAssetOverlay.propTypes = {
  builderBlock: PropTypes.shape({
    id: PropTypes.string,
  }),
  container: PropTypes.string,
  mobileContainer: PropTypes.string,
  overlay: PropTypes.any,
};

export default BuilderAssetOverlay;
